import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const UserStatus = ({ status, setStatus }) => {
    const statusArray = [
        { id: 1, status: "Draft" },
        { id: 2, status: "Active" },
        { id: 3, status: "Inactive" },
        { id: 4, status: "Deleted" },
    ]

    return (
        <div>
            <FormControl size="small" fullWidth disabled>
                <InputLabel>Status</InputLabel>
                <Select
                    label="Status"
                    value={status}
                    onChange={(event) => {
                        setStatus(event.target.value);
                    }}
                >
                    {statusArray.map((item) => (
                        <MenuItem key={item.id} value={item.status}>
                            {item.status}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}

export default UserStatus